import React, { useEffect, useState } from "react";

import { Card, CardBody, CardHeader } from "../../../../_metronic/_partials/controls";
import Table, { dateFormatter } from "../../../components/tables/table";
import { getActiveUsers } from "../../../../api/userCustomer";
import { alertError } from "../../../../utils/logger";


export default function ActiveUsersPage() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const columns = [
        { dataField: "email", text: "Email", sort: true },
        { dataField: "customer.fullName", text: "Company Name", sort: true },
        {
            dataField: "lastConnection",
            text: "Last Connection",
            formatter: dateFormatter,
            sort: true,
        }
    ];

    useEffect(() => {
        getActiveUsers()
            .then((res) => {
                const users = res.data.activeUsers;
                setData(users);
                setFilteredData(users);
            })
            .catch((error) => {
                alertError({ error, customMessage: `Could not get active users.` });
            })
    }, []);

    return (
        <Card>
            <CardHeader title={`Active users list`}>
            </CardHeader>
            <CardBody>
                <Table key={data.length} data={filteredData} columns={columns} />
            </CardBody>
        </Card>
    );
}